import { type DatadogInitOptions } from './datadog';

export type ObservabilityType = 'datadog';
export type ObservabilityTypeInitOptions = {
    datadog: DatadogInitOptions;
};

/**
 * Union type of valid options for the init function.
 *
 * Each type in ObservabilityType is mapped to a new union type with:
 *   - the type as the ObservabilityType value
 *   - the options as the matching item from ObservabilityTypeInitOptions.
 *
 * This will enforce that when a new ObservabilityType is added, it must also be added to ObservabilityTypeInitOptions.
 */
export type ObservabilityInitOptions = {
    [TKey in ObservabilityType]: {
        type: TKey;
        options: ObservabilityTypeInitOptions[TKey];
    };
}[ObservabilityType];

/**
 * Union type of custom RUM action names
 */
export type ObservabilityCustomAction = 'fetch_clip_playback';

export type LogLevel = 'critical' | 'error' | 'warn' | 'info' | 'debug';

/**
 * This should only be used internally, to make it easier to change these levels and/or add additional levels in the future
 */
export const LogLevelPriorities: { [key in LogLevel]: number } = {
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    critical: 5,
};
